import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { cloneDeep as _cloneDeep } from 'lodash';
import { map, take } from 'rxjs/operators';

import { ReplaceVehicleQuickQuoteContext } from '../+state/quick-quote-feature/quick-quote-enum';
import { QuickQuoteFeatureFacade } from '../+state/quick-quote-feature/quick-quote-feature.facade';

@Injectable({ providedIn: 'root' })
export class QuickQuoteResolve {
  constructor(private quickQuoteFeatureFacade: QuickQuoteFeatureFacade) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.quickQuoteFeatureFacade.context$.pipe(
      take(1),
      map(context => {
        if (context === ReplaceVehicleQuickQuoteContext.QUICK_QUOTE) {
          return 'Quick Quote';
        }
        return 'Replace a Vehicle';
      })
    );
  }
}
